import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ApprovalCard from "./ApprovalCard";

const ApprovalGroup = ({ title, count, accentColor, requests, onReview }) => {
  const theme = useTheme();
  const t     = theme.custom;

  if (!count) return null;

  return (
    <Box sx={{ mb: "24px" }}>
      {/* Section header */}
      <Box sx={{
        display: "flex", alignItems: "center", gap: "10px",
        padding: "8px 0", mb: "12px",
        borderBottom: `1px solid ${t.border}`,
      }}>
        <Typography sx={{
          fontFamily: "'DM Mono', monospace",
          fontSize: "8px", letterSpacing: "0.2em",
          textTransform: "uppercase", color: accentColor,
        }}>
          {title}
        </Typography>

        <Box sx={{
          background: `${accentColor}18`,
          border: `1px solid ${accentColor}40`,
          borderRadius: "2px", padding: "1px 8px",
        }}>
          <Typography sx={{
            fontFamily: "'DM Mono', monospace",
            fontSize: "8px", color: accentColor, fontWeight: 600,
          }}>
            {count} {count === 1 ? "request" : "requests"}
          </Typography>
        </Box>
      </Box>

      {/* Cards */}
      {requests.map((req) => (
        <ApprovalCard
          key={req.requestId}
          request={req}
          onReview={onReview}
        />
      ))}
    </Box>
  );
};

export default ApprovalGroup;